import { Progress } from "@/models/progress";
import { Pagination } from "@/models/pagination";
import { IProgress, ProgressState } from "@/types/progress";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<ProgressState, IProgress> = {
  single: (state, single) => {
    state.single = new Progress(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Progress(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Progress();
    state.pagination = new Pagination();
  },
};

export default mutations;
